import { useFetcher } from '@remix-run/react';
import { useEffect, useState } from 'react';

import type { Pagination, Post } from '~/interfaces/post';

interface Props {
  initialPosts: Post[];
  initialPagination: Pagination;
  contentTagIds?: string[];
}

const usePaginateCategoryPosts = ({ initialPosts, initialPagination, contentTagIds }: Props) => {
  const fetcher = useFetcher<{
    posts: Post[];
  }>();
  const totalPages = initialPagination.total_pages;
  const [posts, setPosts] = useState(initialPosts);
  const [page, setPage] = useState(initialPagination.page);
  const fetchedData = fetcher?.data;

  const fetchPosts = () => {
    const searchParams: any = new URLSearchParams();
    searchParams.append('page', page + 1);
    if (contentTagIds) {
      searchParams.append('tags', contentTagIds);
    }

    fetcher.load(`/posts?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (posts) {
      setPage(1);
      setPosts(initialPosts);
    }
  }, [initialPosts]);

  useEffect(() => {
    if (fetchedData) {
      setPage(page + 1);
      setPosts(posts.concat(fetchedData?.posts));
    }
  }, [fetchedData]);

  return {
    postsToRender: posts,
    showLoadMore: page + 1 <= totalPages,
    isLoading: fetcher?.state !== 'idle',
    postsFetcher: fetcher,
    fetchPosts,
  };
};

export default usePaginateCategoryPosts;
